import { DateRange } from 'react-day-picker';

import { EMetric } from 'api/useAnalytics';
import { differenceInDays, subDays } from 'date-fns';


export const BUSINESS_ANALYTICS = [
  EMetric.TOTAL_REVENUE,
  EMetric.TOTAL_REVENUE_WITHOUT_TAX,
  EMetric.ARPU,
  EMetric.ARPPU,
  EMetric.DEPOSITORS,
  EMetric.DEPOSITS,
  EMetric.AVERAGE_DEPOSITS_PER_DEPOSITOR,
  EMetric.ACTIVE_USERS,
  EMetric.SESSIONS,
  EMetric.DAU,
  EMetric.CONVERSION_RATE
];

export const FINANCE_ANALYTICS = [
  EMetric.PAYMENT_SUCCESS_ORDER_RATE,
  EMetric.REFUND_AMOUNT_RATE,
  EMetric.REFUND_RATE,
  EMetric.DISPUTES_RATE,
  EMetric.DISPUTES_WIN_RATE,
  EMetric.DISPUTES_AMOUNT_RATE,
  EMetric.DISPUTES_LOST_COUNT,
  EMetric.DISPUTES_WIN_COUNT,
  EMetric.DISPUTES_IN_PROGRESS_COUNT,
];

export const BUSINESS_BREAKDOWNS_ANALYTICS: EMetric[] = [
  EMetric.DEPOSITS_PER_PRICE_POINT,
  EMetric.REVENUE_PER_PRICE_POINT
];

export const FINANCE_BREAKDOWNS_ANALYTICS: EMetric[] = [
  EMetric.PAYMENT_METHODS_DISTRIBUTION,
  EMetric.REVENUE_PER_COUNTRY,
  EMetric.PAYMENT_METHODS_REVENUE_DISTRIBUTION,
];

export const FINANCE_BREAKDOWNS_ANALYTICS_SCIPLAY: EMetric[] = [
  EMetric.PAYMENT_METHODS_DISTRIBUTION,
  EMetric.REVENUE_PER_COUNTRY,
  EMetric.PAYMENT_METHODS_REVENUE_DISTRIBUTION,
  EMetric.ORDER_SUCCESS_RATE_BY_PAYMENT_METHOD,
];

export const DEFAULT_DATE_RANGE = {
  from: subDays(new Date(), 7),
  to: new Date()
};

export const getWholeRange = (value?: DateRange) => {
  if (value?.from === undefined || value?.to === undefined) {
    return value;
  }

  const fromDate = new Date(
    Date.UTC(
      value.from.getFullYear(),
      value.from.getMonth(),
      value.from.getDate(),
      0,
      0,
      0,
      0
    )
  );

  const toDate = new Date(
    Date.UTC(
      value.to.getFullYear(),
      value.to.getMonth(),
      value.to.getDate(),
      23,
      59,
      59,
      999
    )
  );

  return { from: fromDate, to: toDate };
};

export const getFixedDays = (value?: DateRange): number | undefined => {
  if (!value?.to || !value.from) {
    return undefined;
  }
  return differenceInDays(value.to, value.from);
};

export const isDateStringHourly = (date: string): boolean => {
  return /^\d{1,2}$/.test(date);
};
